import { getProfile, MyProfileModel } from "@dana/Services/DanaMyProfileService";
import { MyProfileActions } from "@dana/Store/Data/MyProfile/Reducers/MyProfileReducer";
import {
    ApiHandler,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { GetAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<GetAccountApiParameter, MyProfileModel, DispatchProp<MyProfileActions>>;


export const DispatchBeginLoadAccount: HandlerType = props => {
    props.dispatch({
        type: "MyProfile/BeginLoad",
        isLoading: true,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        accountId: props.parameter.accountId || API_URL_CURRENT_FRAGMENT,
    };
};

export const GetAccount: HandlerType = async props => {
    try {    
        props.apiResult = await getProfile(props.apiParameter);   
    } catch (error) {
        if ("status" in error && error.status === 403) {
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadProfile: HandlerType = props => {
    props.dispatch({
        type: "MyProfile/CompleteLoadProfile",
        myProfileModel: props.apiResult,
    });
};
export const SetLoadingOff: HandlerType = props => {
    props.dispatch?.({
        type: "MyProfile/EndLoad",
        isLoading: false,
    });
}



export const chain = [
    DispatchBeginLoadAccount,
    PopulateApiParameter,
    GetAccount,
    DispatchCompleteLoadProfile,
    SetLoadingOff
];



const loadMyProfile = createHandlerChainRunner(chain, "MyProfileHandler");
export default loadMyProfile;
